import { render } from "./WatermarkModeIcon.vue?vue&type=template&id=1085c2c7&scoped=true"
import script from "./WatermarkModeIcon.vue?vue&type=script&lang=js"
export * from "./WatermarkModeIcon.vue?vue&type=script&lang=js"

import "./WatermarkModeIcon.vue?vue&type=style&index=0&id=1085c2c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1085c2c7"]])

export default __exports__